import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import 'moment/locale/es'
import {
  IonImg,
  IonAvatar
} from '@ionic/react'
import ReactTooltip from 'react-tooltip'
import { ShareMenu } from '../../../components/common/ShareMenu'
import './styles.scss'
moment.locale('es')

const ReadHeader = (props) => {
  const { content } = props
  const [date, setDate] = useState({ fromNow: '', formated: '' })
  useEffect(() => {
    const date = moment(content.header.date, 'YYYY-MM-DD HH:mm:ss')
    setDate({
      fromNow: date.locale('es').fromNow(),
      formated: date.locale('es').format('dddd MMMM yyyy')
    })
  }, [content])

  return (
    <section className='read-header'>
      <figure itemProp='image' itemScope itemType='http://schema.org/ImageObject'>
        <meta itemProp='height' content={content.header.miniature_height} />
        <meta itemProp='width' content={content.header.miniature_width} />
        <meta itemProp='url' content={content.header.miniature} />
        <IonImg
          src={content.header.miniature}
          alt={content.header.title}
          className='img-banner'
        />
      </figure>

      <section className='share-buttons-container'>
        <ShareMenu
          title={content.header.title}
          intro={content.header.intro}
          tags={content.header.tags}
          section='Yok News'
        />
      </section>

      <section itemProp='publisher' itemScope itemType='http://schema.org/Organization'>
        <meta itemProp='url' content='https://yokradio.com/' />
        <meta itemProp='name' content='Yok Radio' />
        <div itemProp='logo' itemScope itemType='http://schema.org/ImageObject'>
          <meta itemProp='url' content='https://yokradio.com/assets/icon/android-chrome-1024x1024.png' />
        </div>
      </section>

      <section>
        <Link
          itemProp='author'
          className='editor'
          aria-label={`Ver perfil de ${content.header.editor_name}`}
          to={`/editor/${content.header.id_editor}_${content.header.editor_url_name}/1`}
        >
          <IonAvatar>
            <IonImg
              src={content.header.editor_picture}
              alt={`Foto de perfil de ${content.header.editor_picture}`}
            />
          </IonAvatar>
          {content.header.editor_name}
          <span
            className='date'
            data-tip={date.formated}
          >
            {date.fromNow}
            <meta
              itemProp='datePublished'
              content={date.formated}
            />
          </span>
        </Link>

        <h1
          itemProp='headline'
          className='title'
        >
          {content.header.title}
        </h1>

        <p
          itemProp='description'
          className='intro'
        >
          {content.header.intro}
        </p>
      </section>
      <ReactTooltip
        backgroundColor='#ffb300'
      />
    </section>
  )
}

export default ReadHeader
